import { render, staticRenderFns } from "./HomepageLayout_test.vue?vue&type=template&id=2c907138&scoped=true&lang=html&"
import script from "./HomepageLayout_test.vue?vue&type=script&lang=js&"
export * from "./HomepageLayout_test.vue?vue&type=script&lang=js&"
import style0 from "./HomepageLayout_test.vue?vue&type=style&index=0&id=2c907138&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c907138",
  null
  
)

export default component.exports